import { FiEdit2 } from "react-icons/fi";
import { PiImagesSquareThin } from "react-icons/pi";
import { useState } from "react";
import EditableSingleItem from "./EditableSingleItem";
import ImageModal from "../../Inventory/Components/ImageModal";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import TooltipIcon from "./TooltipIcon";

const TopHeader = ({
  index,
  selectedProject,
  item,
  Editing,
  userName,
  setItems,
  roleType,
  updateRequestStatus,
  checkedIndex,
  setCheckedIndex,
  checkedSet,
  setCheckedSet,
}) => {
  const [openEdit, setOpenEdit] = useState(false);

  const imageItems = item.images ? Object.values(item.images) : [];
  const [displayImage, setDisplayImage] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} | ${hours}:${minutes} ${ampm}`;
  }

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const findOldStatus = (oldStatus) => {
    let newStatus;
    if (oldStatus === "Approved") {
      newStatus = "Requested";
    } else if (oldStatus === "Released") {
      newStatus = "Approved";
    } else {
      newStatus = "Requested";
    }
    return newStatus;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: "#FFE9A2",
        height: 50,
        alignItems: "center",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          style={{
            height: 32,
            width: 32,
            borderRadius: 32,
            backgroundColor:
              Object.values(item.requestHistory)[
                Object.values(item.requestHistory).length - 1
              ]["status"] === "Requested" || "Declined"
                ? "#FA722F"
                : Object.values(item.requestHistory)[
                    Object.values(item.requestHistory).length - 1
                  ]["status"] === "Approved"
                ? "#00D226"
                : Object.values(item.requestHistory)[
                    Object.values(item.requestHistory).length - 1
                  ]["status"] === "Released"
                ? "#1485AE"
                : "#828282",
            marginLeft: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {checkedSet !== null && (
            <TooltipIcon
              tooltipText="Uncheck All"
              icon={UnpublishedIcon}
              onClick={() => {
                setCheckedSet(null);
                setCheckedIndex(null);
                setItems((prevState) => {
                  const newState = [...JSON.parse(JSON.stringify(prevState))];

                  const updatedItem = { ...newState[index] };

                  updatedItem["items"] = updatedItem["items"].map((item) => {
                    if (item?.checked === true) {
                      return {
                        ...item,
                        checked: false,
                        status: findOldStatus(item.status),
                      };
                    }
                    return item;
                  });

                  newState[index] = updatedItem;

                  return newState;
                });
              }}
              iconStyle={{ fontSize: 24, color: "#353535" }}
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginLeft: 8,
          }}
        >
          <p style={{ margin: 0, fontSize: "0.92rem" }}>
            {`MR${item.poNumber ? item.poNumber : item.id}  (${
              Object.values(item.requestHistory)[
                Object.values(item.requestHistory).length - 1
              ]["status"]
            } by ${
              Object.values(item.requestHistory)[
                Object.values(item.requestHistory).length - 1
              ]["name"]
            }) | ${selectedProject.projectName}`}
            <span style={{ fontWeight: "500" }}>{` | Due: ${
              item.dueDate === "" ? "NA" : formatDateToDDMMYYYY(item.dueDate)
            } | Items: ${Object.values(item.items).length}`}</span>
          </p>
          <p style={{ fontSize: "0.78rem", margin: 0 }}>
            {`${formatTimestamp(item.id)}`}
          </p>
        </div>
      </div>

      {!Editing && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            marginRight: 8,
          }}
        >
          {roleType !== "Viewer" && (
            <FiEdit2
              style={{ cursor: "pointer" }}
              size={18}
              color={"#696969"}
              title="Edit"
              onClick={() => setOpenEdit(true)}
            />
          )}

          <PiImagesSquareThin
            style={{ cursor: "pointer" }}
            size={24}
            color={"#696969"}
            title="View Images"
            onClick={() => setDisplayImage(true)}
          />

          {item.invoiceURL && (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "8px 16px",
                fontSize: "0.875rem",
                backgroundColor: isHovered ? "#b88a29" : "#d19936",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "600",
                transition: "all 0.2s ease-in-out",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.15)",
              }}
              // onClick={() => window.open("", "_blank")}
              onClick={() => window.open(item.invoiceURL, "_blank")}
              title="View Purchase Order"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <line x1="10" y1="9" x2="8" y2="9"></line>
              </svg>
              {/* View PO */}
            </button>
          )}
        </div>
      )}

      <EditableSingleItem
        index={index}
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        selectedProject={selectedProject}
        item={item}
        userName={userName}
        roleType={roleType}
        updateRequestStatus={updateRequestStatus}
      />

      {displayImage && (
        <ImageModal
          images={imageItems}
          selectedImageIndex={0}
          onClose={() => {
            setDisplayImage(false);
          }}
        />
      )}
    </div>
  );
};

export default TopHeader;
